import React from 'react';
import { CheckCircle2, Award, Users, Heart } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const About = () => {
  const features = [
    {
      icon: Award,
      title: 'Od roku 2005',
      description: 'Více než 20 let zkušeností s péčí o spokojené hosty'
    },
    {
      icon: Users,
      title: 'Rodinný přístup',
      description: 'Přátelská atmosféra a osobní péče o každého návštěvníka'
    },
    {
      icon: CheckCircle2,
      title: 'Kompletně oploceno',
      description: 'Bezpečné a soukromé prostředí pro celou rodinu'
    }
  ];

  const highlights = [
    'Kompletně oplocený areál pro maximální bezpečí',
    'Renovované sociální zařízení (2020)',
    'Nové dětské hřiště',
    'Vlastní restaurace a venkovní bar',
    'WiFi s výborným signálem v celém areálu',
    'Služba 24 hodin denně, 7 dní v týdnu'
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-emerald-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            O kempu Josef
          </h2>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 leading-relaxed">
            Kemp Josef byl založen v roce 2005 jako rodinný podnik s přátelskou atmosférou. 
            Nacházíme se v malebné vinařské oblasti jižní Moravy, přibližně 10 km od Hodonína.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {features.map((feature, index) => (
            <Card
              key={index}
              className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-emerald-200"
            >
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-emerald-600 transition-colors">
                  <feature.icon className="w-8 h-8 text-emerald-600 group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://i.ibb.co/Ndfr9yhq/IMG-20260408-WA0001.jpg"
                alt="Kemp Josef Areál"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-emerald-200 rounded-2xl -z-10"></div>
          </div>

          {/* Highlights */}
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Proč si vybrat Kemp Josef?
            </h3>
            <div className="space-y-4">
              {highlights.map((highlight, index) => (
                <div
                  key={index}
                  className="flex items-start space-x-4 group"
                >
                  <div className="flex-shrink-0">
                    <CheckCircle2 className="w-6 h-6 text-emerald-600 group-hover:scale-110 transition-transform" />
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    {highlight}
                  </p>
                </div>
              ))}
            </div>

            <div className="pt-6">
              <Card className="bg-gradient-to-br from-emerald-600 to-emerald-700 border-0">
                <CardContent className="p-6 text-white">
                  <p className="text-lg font-medium mb-2">
                    Rovinatý areál v krásné přírodě
                  </p>
                  <p className="text-emerald-100">
                    Ideální pro rodiny s dětmi, sportovní akce, firemní eventy i romantické svatby
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
